export enum CourseInvitationType {
  CreateRestrictedUser = "createRestrictedUser",
  SendEmail = "sendEmail",
  SendSms = "sendSms",
}
